import { Injectable } from '@angular/core';
import { errorMessageData } from './error-message.data';
import { ITEM } from '@utils/constants';
@Injectable({
    providedIn: 'root'
})
// file unit test nya mana
export class ErrorMessageService {
    getErrorMessage(statusCode: string, msisdn: number) {
        const error = errorMessageData.find(item => item.statusCode === statusCode);
        return error ? {...error, msisdn: msisdn?.toString()} : {...errorMessageData[ITEM.START_INDEX], msisdn: msisdn?.toString()};
    }
}
